import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setAdminToken } from "@/lib/api";
import { Shield } from "lucide-react";
import { toast } from "sonner";
import BrandLogo from "@/components/BrandLogo";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e?.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/admin/login", { password });
      setAdminToken(r.data.token);
      toast.success("Welcome back, admin.");
      navigate("/admin/dashboard");
    } catch (e) {
      toast.error("Wrong password");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#FDFBF7]">
      <form onSubmit={submit} className="brutal-card p-8 w-full max-w-md">
        <div className="mb-6">
          <BrandLogo size="lg" title="Admin Login" subtitle="TekWissen Fun Zone Control Center" />
        </div>
        <label className="text-xs font-black uppercase mb-2 block">Password</label>
        <input
          data-testid="admin-password-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="brutal-input"
          autoFocus
          required
        />
        <button data-testid="admin-login-submit" type="submit" disabled={busy} className="brutal-btn w-full mt-6 flex items-center justify-center gap-2">
          <Shield size={18}/> {busy ? "Logging in…" : "Enter Dashboard"}
        </button>
      </form>
    </div>
  );
}
